<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-tab-footer">
        <el-form
          class="box"
          ref="productForm"
          :model="product"
          label-width="70px"
        >
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.productNo')">{{
                  product.productNo
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.name')">{{
                  product.name
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.life')" :prop="'life'">
                  <span v-if="product.life !== null && product.life !== 0">
                    {{ product.life }}{{ $t("text.month") }}
                  </span>
                  <span v-else class="grey">没设置</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.category')">{{
                  product.categoryName
                }}</el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('product.brand')">{{
                  product.brandName
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.unit')">{{
                  product.unit
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.salesPrice')"
                  :prop="'salesPrice'"
                >
                  {{ product.salesPrice | currency }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.costPrice')"
                  :prop="'costPrice'"
                >
                  {{ product.costPrice | currency }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.rentPrice')"
                  :prop="'rentPrice'"
                >
                  {{ product.rentPrice | currency }}
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('text.createAt')" :prop="'createAt'">
                  {{ product.createdAt }}
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <el-row :gutter="10">
            <el-col :span="14">
              <fieldset
                v-if="product.colors && product.colors.length != 0"
                class="mgb15"
              >
                <legend>{{ $t("product.color") }}</legend>
                <el-tag
                  v-for="color in product.colors"
                  :key="color"
                  type="info"
                  >{{ color }}</el-tag
                >
              </fieldset>
              <fieldset
                v-if="product.sizes && product.sizes.length != 0"
                class="mgb15"
              >
                <legend>{{ $t("product.size") }}</legend>
                <el-tag v-for="size in product.sizes" :key="size" type="info">{{
                  size
                }}</el-tag>
              </fieldset>

              <fieldset v-if="product.introduction != null" class="mgb15">
                <legend>{{ $t("product.introduction") }}</legend>
                <raw-html :content="product.introduction" />
              </fieldset>
            </el-col>
            <el-col :span="10">
              <fieldset v-if="product.images != null" class="mgb15">
                <legend>{{ $t("product.images") }}</legend>
                <thumbnail
                  :images="product.images"
                  :list="true"
                  width="50"
                  height="auto"
                />
              </fieldset>
            </el-col>
          </el-row>
          <fieldset class="mgb15">
            <legend>{{ $t("product.productSupplier") }}</legend>
            <vxe-table
              :data="product.productSuppliers"
              ref="recordsTable"
              class="recordsTable"
              size="mini"
              resizable
              highlight-hover-row
              auto-resize
              border
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="supplierName"
                :title="$t('menu.suppliers')"
              />

              <vxe-table-column
                field="productNo"
                :title="$t('product.supplierProductNo')"
              />
              <vxe-table-column
                field="defaultSupplier"
                :title="$t('product.defaultSupplier')"
                width="90"
              >
                <template v-slot="{ row }">
                  {{ $t("boolean." + row.defaultSupplier) }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="remark"
                :title="$t('text.remark')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  <raw-html-limit-number :content="row.remark" :number="12" />
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="action"
                :title="$t('text.action')"
                width="180"
                v-if="Permit.canActions('productManage')"
                fixed="right"
              >
                <template v-slot="{ row }">
                  <el-button
                    type="text"
                    size="mini"
                    @click="editProductSupplier(row)"
                    >{{ $t("text.edit") }}</el-button
                  >
                  <el-popconfirm
                    :title="$t('prompt.confirmDelete')"
                    @confirm="deleteProductSupplier(row)"
                    class="mgl10 mgr10"
                  >
                    <el-button slot="reference" type="text" size="mini">
                      {{ $t("text.delete") }}
                    </el-button>
                  </el-popconfirm>
                  <el-button
                    v-if="!row.defaultSupplier"
                    type="text"
                    size="mini"
                    @click="setDefaultSupplier(row)"
                    >{{ $t("action.setDefaultSupplier") }}</el-button
                  >
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer" v-if="Permit.canActions('productManage')">
      <el-button type="primary" size="small" @click="copy">
        {{ $t("action.copy") }}
      </el-button>
      <el-button type="success" size="small" @click="addSupplier">
        + {{ $t("product.productSupplier") }}
      </el-button>
    </div>
    <!-- 产品复制 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.copy')"
      :close-on-click-modal="false"
      :visible.sync="copyDF"
      width="30%"
    >
      <el-form ref="copyObjForm" :model="copyObj" label-width="60px">
        <el-form-item
          :label="$t('product.productNo')"
          :prop="'productNo'"
          :rules="[
            {
              required: true,
              validator: validateProductNo,
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="copyObj.productNo" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="copySubmitDoing"
          size="small"
          @click="copySubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="copyDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 编辑供应商报价 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('product.productSupplier')])"
      :visible.sync="editProductSupplierDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="editProductSupplierObjForm"
        :model="editProductSupplierObj"
        label-width="90px"
      >
        <el-form-item
          :prop="'productNo'"
          :label="$t('product.supplierProductNo')"
        >
          <el-input
            size="small"
            v-model.trim="editProductSupplierObj.productNo"
          />
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="editProductSupplierObj.remark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editProductSupplierSubmitDoing"
          size="small"
          @click="editProductSupplierSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editProductSupplierDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增产品供应商 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('product.supplierPrice')])"
      :close-on-click-modal="false"
      :visible.sync="addProductSupplierDF"
      width="50%"
    >
      <el-form ref="addSupplierForm" :model="addSupplierObj">
        <div v-for="(item, index) in addSupplierObj.items" :key="index">
          <el-row :gutter="10">
            <el-col :span="7">
              <el-form-item>
                <el-select
                  size="small"
                  v-model="item.supplierId"
                  clearable
                  filterable
                  :placeholder="
                    $t('rules.mustFillSimple', [$t('menu.suppliers')])
                  "
                  @change="existJudgeProductSupplier(index)"
                >
                  <el-option
                    v-for="supplier in addProductSupplierSuppliers"
                    :key="supplier.id"
                    :label="supplier.name"
                    :value="supplier.id"
                  />
                </el-select>
                <small v-if="item._localRepeat" class="red">{{
                  $t("rules.filledIn", [$t("menu.suppliers")])
                }}</small>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item>
                <el-input
                  size="small"
                  v-model.trim="item.productNo"
                  :placeholder="$t('product.supplierProductNo')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item>
                <el-input
                  size="small"
                  v-model.trim="item.remark"
                  :placeholder="$t('text.remark')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item>
                <i
                  v-if="index"
                  class="el-icon-delete red"
                  @click="removeSupplier(index)"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-button
                type="success"
                plain
                icon="el-icon-plus"
                size="mini"
                @click="addMoreSupplier"
                >{{ $t("text.create") }}</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addSupplierSubmitDoing"
          size="small"
          @click="addSupplierSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addProductSupplierDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import RawHtml from "@/components/RawHtml";
import Product from "@/api/product.js";
import Supplier from "@/api/supplier.js";
function buildProductSupplier() {
  return {
    productId: null,
    supplierId: null,
    defaultSupplier: false,
    productNo: null,
    remark: null,
    _localRepeat: false,
  };
}

export default {
  props: {
    id: null,
  },
  mixins: [page, table.pager, table.search, table.checker],
  components: {
    Thumbnail,
    RawHtml,
  },
  data() {
    var validateProductNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("product.productNo")]))
        );
        return;
      }
      Product.findByProductNo({ productNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("product.productNo")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      product: { uuid: null },
      asyncImageToInvDoing: false,

      // 复制
      validateProductNo: validateProductNo,
      copyDF: false,
      copyObj: {
        productNo: null,
      },
      copySubmitDoing: false,
      // 编辑供应商
      editProductSupplierDF: false,
      row: null,
      editProductSupplierObj: {
        productNo: null,
        remark: null,
      },
      editProductSupplierSubmitDoing: false,
      // 新增供应商
      addProductSupplierDF: false,
      suppliers: [],
      addProductSupplierSuppliers: [],
      addSupplierObj: {
        items: [],
      },
      addSupplierSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    self.getProduct();
  },
  methods: {
    getProduct() {
      const self = this;
      self.loadingStart();
      Product.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.product = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },

    // 新增产品供应商
    addSupplier() {
      const self = this;
      self.addSupplierSubmitDoing = false;
      Supplier.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.suppliers = res.data;
          const productSupplierIds = self.product.productSuppliers.map(
            (s) => s.supplierId
          );
          self.addProductSupplierSuppliers = self.suppliers.filter(
            (s) => !productSupplierIds.includes(s.id)
          );
          const newBuildProductSupplier = buildProductSupplier();
          self.addSupplierObj.items = [
            JSON.parse(JSON.stringify(newBuildProductSupplier)),
            JSON.parse(JSON.stringify(newBuildProductSupplier)),
            JSON.parse(JSON.stringify(newBuildProductSupplier)),
          ];
          self.addProductSupplierDF = true;
        } else {
          self.sysError();
        }
      });
    },
    removeSupplier(index) {
      this.addSupplierObj.items.splice(index, 1);
    },
    addMoreSupplier() {
      const self = this;
      const newBuildProductSupplier = buildProductSupplier();
      this.addSupplierObj.items.push(newBuildProductSupplier);
    },
    existJudgeProductSupplier(idx) {
      const self = this;
      this.addSupplierObj.items[idx]._localRepeat = false;
      if (this.addSupplierObj.items[idx].supplierId != null) {
        // 本地过滤
        const iis = self.addSupplierObj.items.filter(function (s) {
          return s.supplierId === self.addSupplierObj.items[idx].supplierId;
        });
        if (iis.length > 1) {
          this.addSupplierObj.items[idx]._localRepeat = true;
        }
      }
    },
    addSupplierSubmit() {
      const self = this;
      const items = this.addSupplierObj.items.filter(function (item) {
        return item.supplierId != null;
      });
      if (items.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastFillInOneValidData"),
          type: "warning",
        });
        return;
      }
      const errDatas = items.filter((s) => s._localRepeat === true);
      if (errDatas.length !== 0) {
        self.$message({
          message: this.$t("prompt.errorMessage"),
          type: "warning",
        });
        return;
      }
      for (const i of items) {
        i.productId = self.product.id;
      }
      if (self.product.productSuppliers.length === 0) {
        items[0].defaultSupplier = true;
      }
      self.addSupplierSubmitDoing = true;
      Product.createProductSupplier(items).then(function (res) {
        self.addSupplierSubmitDoing = false;
        self.addProductSupplierDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.getProduct();
        } else {
          self.sysError();
        }
      });
    },
    // 设置默认供应商
    setDefaultSupplier(row) {
      const self = this;
      Product.updateDefaultSupplier(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.setSuccess"),
            type: "success",
          });
          self.getProduct();
        } else {
          self.sysError();
        }
      });
    },
    // 删除产品供应商
    deleteProductSupplier(row) {
      const self = this;
      Product.deleteProductSupplier(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.getProduct();
        } else {
          self.sysError();
        }
      });
    },
    // 编辑产品供应商
    editProductSupplier(row) {
      const self = this;
      self.row = row;
      self.editProductSupplierObj.productNo = row.productNo;
      self.editProductSupplierObj.remark = row.remark;
      self.editProductSupplierSubmitDoing = false;
      self.editProductSupplierDF = true;
    },
    editProductSupplierSubmit() {
      const self = this;
      this.$refs.editProductSupplierObjForm.validate((valid) => {
        if (valid) {
          self.editProductSupplierSubmitDoing = true;
          Product.updateProductSupplier(
            self.row.id,
            self.editProductSupplierObj
          ).then(function (res) {
            self.editProductSupplierSubmitDoing = false;
            self.editProductSupplierDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.getProduct();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    //产品复制
    copy() {
      const self = this;
      self.copyObj.productNo = self.product.productNo + "Copy";
      self.copySubmitDoing = false;
      self.copyDF = true;
    },
    copySubmit() {
      const self = this;
      this.$refs.copyObjForm.validate((valid) => {
        if (valid) {
          self.copySubmitDoing = true;
          Product.copy(self.product.id, self.copyObj).then(function (res) {
            self.copySubmitDoing = false;
            self.copyDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.copySuccess"),
                type: "success",
              });
              self.$emit("updateInfo");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // //
    // asyncImageToInv() {
    //   const self = this;
    //   self.asyncImageToInvDoing = true;
    //   Product.asyncImageToInv(self.product.id).then(function (res) {
    //     self.asyncImageToInvDoing = false;
    //     if (res.status === 200) {
    //       self.$message({
    //         message: self.$t("prompt.asyncSuccess"),
    //         type: "success",
    //       });
    //     } else {
    //       self.sysError();
    //     }
    //   });
    // },
  },
};
</script>